















































































import { Vue, Component, Lifecycle, Mixin } from "av-ts";
import { IQuestion, ITopic } from "../../interfaces/models";

import UserService from "../../services/UserService";
import TopicService from "../../services/TopicService";
import Fetcher from "../../services/Fetcher";

import ActionButtons from "../util/ActionButtons.vue";
import QuestionSearch from "./QuestionSearch.vue";
import QuestionPreview from "./QuestionPreview.vue";
import QuestionCards from "./QuestionCards.vue";
import Question from "./Question.vue";
import VariableDataVisualiser from "../charts/VariableDataVisualiser.vue";
import responsiveMixin from "../../responsiveMixin";


@Component({
    components: {
        ActionButtons,
        VariableDataVisualiser,
        QuestionSearch,
        QuestionPreview,
        QuestionCards,
        Question
    }
})
export default class QuestionBrowser extends mixin(responsiveMixin, Vue) {

    pTopics: ITopic[] = [];

    pPage = 1;
    pPageSize = 25;
    pQuestionCount = 0;

    searchedQuestions: IQuestion[] = [];
    topicsToUse: ITopic[] = [];

    updateTopics(topics: ITopic[]) {
        this.pTopics = topics;
    };

    @Lifecycle
    created() {
        Fetcher.get(TopicService.getAllAvailableTopics)
            .on(this.updateTopics);
    }

    @Lifecycle
    destroyed() {
        Fetcher.get(TopicService.getAllAvailableTopics)
            .off(this.updateTopics);
    }

    get topics() {
        return this.pTopics;
    }

    get showQuestions() {
        return this.searchedQuestions;
    }

    changeDisplay(searchedQuestions: { questions: IQuestion[], page: number, totalItems: number }) {
        this.pPage = searchedQuestions.page;
        this.searchedQuestions = searchedQuestions.questions;
        this.pQuestionCount = searchedQuestions.totalItems;
    }

    filterQuestionTopic(topicsToUse: ITopic[]) {
        this.topicsToUse = topicsToUse;
    }

    generateCompetencies() {
        return UserService.userCompetencies;
    }

    get page() {
        return this.pPage;
    }

    get pageSize() {
        return this.pPageSize;
    }

    get totalQuestions() {
        return this.pQuestionCount;
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/questions/QuestionBrowser.vue